import { useTranslation } from "react-i18next";
import { Button } from "@/shared/components/ui/button";
import { ShieldAlert, Home } from "lucide-react";
import { Link } from "react-router-dom";

const AccessDenied = () => {
  const { t } = useTranslation();

  return (
    <div className="flex h-screen w-full flex-col items-center justify-center gap-6 text-center">
      <div className="flex flex-col items-center gap-2">
        <ShieldAlert className="h-16 w-16 text-destructive" />
        <h1 className="text-4xl font-bold tracking-tight">
          {t("errors.accessDenied.title", "Acesso Negado")}
        </h1>
        <p className="text-lg text-muted-foreground max-w-md">
          {t(
            "errors.accessDenied.description",
            "Você não tem permissão para acessar esta página. Esta área é restrita apenas para administradores."
          )}
        </p>
      </div>

      <div className="flex gap-4">
        <Button variant="default" asChild>
          <Link to="/">
            <Home className="mr-2 h-4 w-4" />
            {t("common.backToHome", "Voltar para Home")}
          </Link>
        </Button>
      </div>
    </div>
  );
};

export default AccessDenied;
